import axios from 'axios'

// eslint-disable-next-line no-console
export const cloudFunctionInstance = axios.create({
  baseURL: process.env.REACT_APP_FUNCTIONS_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor
cloudFunctionInstance.interceptors.request.use(
  config => config,
  error => Promise.reject(error),
)

// Add response interceptor
cloudFunctionInstance.interceptors.response.use(
  response => response,
  error => {
    console.error('API request failed:', error)
    return Promise.reject(error)
  },
)
